import { useEffect } from "react";
import { useParams } from "react-router-dom";
import styled, { css } from "styled-components";
import tw from "twin.macro";
import { setUserDetailsStore, useUserDetailsStore } from "..";
import { DP } from "../../../common/types";
import { fetchUserDetailsPosts } from "../api";
import Post from "./Post";

interface Props extends DP {}

const Posts = (props: Props) => {
  const isPostsLoading = useUserDetailsStore((s) => s.isPostsLoading);
  const posts = useUserDetailsStore((s) => s.posts);
	const currentPage = useUserDetailsStore((s) => s.currentPage)
  const isFetching = useUserDetailsStore((s) => s.isFetching);
  const { username } = useParams();


  useEffect(() => {
    if (isFetching) {
      fetchUserDetailsPosts();
    }
  }, [isFetching]);


  useEffect(() => {
    if (!isFetching) {
    	setUserDetailsStore({posts: [], page: 0, isPostsLoading: true });
    	fetchUserDetailsPosts();
    }
  }, [username, currentPage]);

  if (isPostsLoading) return null;
  if (!posts.length || !posts)
    return <NotFound className={props.className}>Not found</NotFound>;

  return (
    <Wrapper>
      {posts.map((el) => (
        <Post key={el._id} post={el} />
      ))}
    </Wrapper>
  );
};

const Wrapper = styled.div(() => [
  tw`mb-4`,
  css`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(calc(3rem + 5vh), 1fr));
    gap: 0.5rem;
  `,
]);

const NotFound = styled.p(() => [
  tw`italic text-[0.5rem] text-gray-400 opacity-75`,
]);

export default styled(Posts)``;
